import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon-plus" }, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "list-disc ml-5 mt-1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { class: "list-disc ml-5 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_proposal_suppliers_form = _resolveComponent("proposal-suppliers-form")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_outline_button, {
      type: "outline",
      onClick: _ctx.openModal
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.products.add.button')), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.modalVisibility,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisibility) = $event)),
      "buttons-position": "right",
      size: "tall",
      "block-confirm": !_ctx.hasSelectedSuppliers,
      onConfirmClick: _ctx.handleAdd
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.products.add.title')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_proposal_suppliers_form)
      ]),
      "confirm-button": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('proposal.products.add.apply')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "block-confirm", "onConfirmClick"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showNotice,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showNotice) = $event)),
      type: "warning",
      "hide-cancel-button": true,
      onConfirmClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNotice = false))
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.products.add.notice_title')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.nothingAdded)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('proposal.products.add.nothing_added')), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.products.add.added_intro')), 1),
              _createElementVNode("ul", _hoisted_3, [
                (_ctx.added.outbound)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_ctx.$t('proposal.products.add.added_outbound', { count: _ctx.added.outbound })), 1))
                  : _createCommentVNode("", true),
                (_ctx.added.returns)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_ctx.$t('proposal.products.add.added_returns', { count: _ctx.added.returns })), 1))
                  : _createCommentVNode("", true),
                (_ctx.added.surcharges)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(_ctx.$t('proposal.products.add.added_surcharges', { count: _ctx.added.surcharges })), 1))
                  : _createCommentVNode("", true),
                (_ctx.added.brackets)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(_ctx.$t('proposal.products.add.added_brackets', { count: _ctx.added.brackets })), 1))
                  : _createCommentVNode("", true)
              ])
            ], 64)),
        (_ctx.skipped.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('proposal.products.add.skipped_intro', { count: _ctx.skipped.length })), 1),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skipped, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                }), 128))
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      "confirm-button": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('general.ok')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}